import Hero from "../sections/hero";
import DesignPage from "../sections/designPage";
import Footer from "../sections/footer";

function Design() {
  return (
    <div>
      <Hero
        heroImg={"designHero"}
        title={"TURNING MUNDANE AND PRACTICAL INTO MAGNIFICENT AND PEERLESS"}
      />
      <DesignPage />
      <Footer />
    </div>
  );
}

export default Design;
